module.exports = __webpack_public_path__ + "img/the-nft-playground.23e723fe.png";